import Image from "next/legacy/image"
import { useMediaPredicate } from "react-media-hook"
import { truncateString } from "@/lib/helpers/utils"
import Button from "@/common/button/button"
import HeadingLabel from "@/common/partials/headingLabel/headingLabel"
import useStrings from "@/lib/hooks/useStrings"
import classNames from "classnames"

export default function Byline({ byline }) {
  const sendMail = () => {
    window.location = "mailto:" + byline.email
  }

  let truncatedEmail = byline.email
  const isSmallMobile = useMediaPredicate("(max-width: 320px)")
  const isMobile = useMediaPredicate("(max-width: 640px)")
  const hasAvatar = byline?.avatar?.url
  const { contact } = useStrings()

  if (isSmallMobile) {
    truncatedEmail = truncateString(byline.email, 20)
  } else if (isMobile) {
    truncatedEmail = truncateString(byline.email, 30)
  }

  return (
    <div className="box-content max-w-screen-sm px-4 mx-auto mb-10 md:mb-15 lg:mb-20 sm:px-10 md:max-w-1xl">
      <div className="flex justify-between pt-3 space-x-5 border-t-2 border-solid border-black-100/10 items-top post-byline-wrapper">
        <Avatar {...{ byline }} />
        <div
          className={classNames([
            "flex-grow font-sans md:flex",
            { '"w-full justify-between': hasAvatar }
          ])}>
          <div className="md:flex-grow text-wrapper">
            <HeadingLabel className="block">{byline.position}</HeadingLabel>
            <span className="block pb-1 font-medium">{byline.name}</span>
            {byline.desc.length > 0 && (
              <span
                className="block pb-2 pr-5 text-sm leading-6 md:text-base md:leading-7"
                dangerouslySetInnerHTML={{ __html: byline.desc }}></span>
            )}
            {byline.email && (
              <div className="max-w-full">
                <a
                  href={`mailto:${byline.email}`}
                  className="text-sm leading-normal">
                  {truncatedEmail}
                </a>
              </div>
            )}
            <Phone {...{ byline }} />
          </div>

          {byline.email && (
            <div className="mt-4 button-wrapper md:mt-7">
              <Button
                size="small"
                theme="good-green"
                ariaLabel="Ta kontakt"
                onClick={sendMail}
                className="block no-print">
                {contact ?? "Ta kontakt"}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const Avatar = ({ byline }) => {
  if (!byline?.avatar?.url) {
    return null
  }

  return (
    <div className="flex-none">
      {byline.avatar.url && (
        <figure className="rounded-full aspect-w-16 aspect-h-16 w-icon-xxl h-icon-xxl">
          <Image
            className="object-cover object-center w-full h-full rounded-full"
            src={byline.avatar.url}
            sizes="256px"
            alt={byline.avatar.alt}
            layout="fill"
            loading="lazy"
          />
        </figure>
      )}
    </div>
  )
}

const Phone = ({ byline }) => {
  if (!byline || (!byline.phone && !byline.altPhone)) {
    return null
  }

  const links = []

  if (byline.phone) {
    links.push(
      <a
        key="phone"
        href={`tel: ${byline.phone}`}
        className="inline-block text-sm leading-normal">
        {byline.phone}
      </a>
    )

    if (byline.altPhone) {
      links.push(
        <span
          key="separator"
          className="inline-block px-1 text-sm leading-normal">
          /
        </span>
      )
    }
  }

  if (byline.altPhone) {
    links.push(
      <a
        key="alt-phone"
        href={`tel: ${byline.altPhone}`}
        className="inline-block text-sm leading-normal">
        {byline.altPhone}
      </a>
    )
  }

  return links
}
